package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.sections.cities.CitiesIndexContent
import com.varabyte.kobweb.core.Page

@Page("/cities")
@Composable
fun CitiesPage() = CitiesIndexContent()
